import { Environment } from "@mobi-office-ui";

// Host Reader
let APP_NAME: string = "";
let COMPANY_NAME: string = "";

if (window && "location" in window && "protocol" in window.location && "pathname" in window.location && "host" in window.location) {
  APP_NAME = window.location.hostname.split(".")[1];
  COMPANY_NAME = window.location.hostname.split(".")[0];
}

if (APP_NAME == "localhost" || COMPANY_NAME == "localhost") {
  COMPANY_NAME = "vm-test";
  APP_NAME = "vmadmin";
}

export const environment: Environment = {
  PRODUCTION: false,
  COMPANY_NAME: COMPANY_NAME,
  APP_NAME: APP_NAME,
  BASE_API: "",
  USER_API: "https://dev-api.dia-dna-um.mobioffice.io",
  // USER_API: "http://192.168.7.200:3007",
};
